export const TIME_FORMAT_DATE = 'dd/MM/yyyy';
export const TIME_FORMAT_DATE_TIME = `${TIME_FORMAT_DATE} HH:mm`;
export const TIME_FORMAT_DATE_EXCEL = 'yyyy-MM-dd';

export const IS_DEV = import.meta.env.DEV
export const IS_DEV_BUILD = import.meta.env.VITE_APP_ENV === 'development';

export const PIPELINE_VARIABLES = {
  api: import.meta.env.VITE_API_SERVER,
  botBaseUrl: import.meta.env.VITE_BOT_BASE_URL,
  botUserProfileID: import.meta.env.VITE_BOT_USER_PROFILE_ID,
  botPropertyCode: import.meta.env.VITE_BOT_PROPERTY_CODE,
};

export const FilterGridItemBreakPoints = {
  xs: 12,
  sm: 6,
  md: 4,
  lg: 3,
  xxl: 2.4,
};
